import { useAppSelector } from '@store';
import ExpandableRow from './expandable-row';
import ExpandableRowContent from './expandable-row-content';
import { RiskScoringTypes } from '../../../hoc/customers/types';
import { AmlComponentProps } from './types';

const SourceOfFunds = ({
  expandedRows,
  setExpandedRows,
  values,
  // onSend,
  // onDelete,
  isEditable,
}: AmlComponentProps) => {
  const { sourcesOfFunds } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  return (
    <ExpandableRow
      name={RiskScoringTypes.SOURCE_OF_FUNDS}
      title="Source of Funds"
      expandedRows={expandedRows}
      setExpandedRows={setExpandedRows}
      totalRisk={values?.sourcesOfFundsRiskTotal as number}
      // comments={[]}
      // onSend={onSend}
      // onDelete={onDelete}
    >
      {values?.sourcesOfFundsRiskItems?.map((item) => (
        <ExpandableRowContent
          key={item.id}
          value={
            sourcesOfFunds?.find((source) => source.value === item.id)
              ?.name as string
          }
          risk={
            item.value?.toString() !== 'null' &&
            item.value?.toString() !== 'undefined'
              ? item.value?.toString()
              : '-'
          }
          name={
            sourcesOfFunds?.find((source) => source.value === item.id)?.name
          }
          isEditable={isEditable}
        />
      ))}
    </ExpandableRow>
  );
};

export default SourceOfFunds;
